import { PaletteOptions } from '@mui/material';

const LightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#1976d2',
  },
  secondary: {
    main: '#212121',
  },
  success: {
    main: '#02a646',
  },
  info: {
    main: '#1976d2',
  },
  warning: {
    main: '#ffc400',
  },
  text: {
    primary: '#2d3748',
  },
};

export default LightPalette;
